export default __webpack_public_path__ + "static/decoration-2-64ee87df94537898d0b49e2b94937065.png";